import { DomainMessagesTypes } from 'shared/domain/messages/message';
import { workflowContract } from 'shared/domain/workflow/workflowContract';
import { makeEventPublisher } from 'serviceWorker/broadcasts/publishers';

/** Outcomes of workflow changes, each with the `uniqueId` of its command. */
export const broadcastCreatedWorkflow = makeEventPublisher(workflowContract, DomainMessagesTypes.createdWorkflow);
export const broadcastUpdatedWorkflow = makeEventPublisher(workflowContract, DomainMessagesTypes.updatedWorkflow);
export const broadcastCreatedStage = makeEventPublisher(workflowContract, DomainMessagesTypes.createdStage);
export const broadcastUpdatedStage = makeEventPublisher(workflowContract, DomainMessagesTypes.updatedStage);
export const broadcastDeletedStage = makeEventPublisher(workflowContract, DomainMessagesTypes.deletedStage);
export const broadcastReorderedStage = makeEventPublisher(workflowContract, DomainMessagesTypes.reorderedStage);
export const broadcastCreatedDecision = makeEventPublisher(workflowContract, DomainMessagesTypes.createdDecision);
